import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";

const Admin_Schedule_map_up = () => {
  const [idxList, setIdxList] = useState([]); // IDX 및 주소 리스트
  const [isNaverMapLoaded, setIsNaverMapLoaded] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
	const titleElement = document.getElementsByTagName("title")[0];
	titleElement.innerHTML = `아소비 관리자 페이지`;
	
    // sessionStorage에서 idxList 가져오기
    const storedIdxList = sessionStorage.getItem("idxList");
    if (storedIdxList) {
      setIdxList(JSON.parse(storedIdxList));
    }

    // 네이버 지도 API 스크립트 로드
    const loadNaverMapScript = () => {
      const script = document.createElement("script");
      script.src =
        "https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=e3bicfy9c4&submodules=geocoder";
      script.onload = () => setIsNaverMapLoaded(true);
      script.onerror = (err) =>
        console.error("네이버 지도 API 로드 실패:", err);
      document.body.appendChild(script);
    };

    loadNaverMapScript();
	
	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, []);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  const getCoordinatesFromAddress = (address) => {
    return new Promise((resolve, reject) => {
      if (!isNaverMapLoaded) {
        reject(new Error("네이버 지도 API가 로드되지 않았습니다."));
        return;
      }

      window.naver.maps.Service.geocode(
        { query: address },
        (status, response) => {
          if (
            status === window.naver.maps.Service.Status.OK &&
            response.v2.addresses.length > 0
          ) {
            const { x, y } = response.v2.addresses[0];
            resolve({ urlX: y, urlY: x });
          } else {
            reject(new Error(`주소 변환 실패: ${address}`));
          }
        }
      );
    });
  };

  const retryGeocode = async (address, retries = 3) => {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        return await getCoordinatesFromAddress(address);
      } catch (err) {
        console.error(
          `좌표 변환 실패 (${address}), 재시도 중 (${attempt}/${retries}):`,
          err
        );
        if (attempt === retries) throw err;
      }
    }
  };

  const processWithBatching = async (items, batchSize = 15) => {
    const results = [];
    for (let i = 0; i < items.length; i += batchSize) {
      const batch = items.slice(i, i + batchSize);
      const batchResults = await Promise.all(
        batch.map(async (item) => {
          try {
            const { idx, addr } = item;
            const { urlX, urlY } = await retryGeocode(addr);
            return { idx, urlX, urlY };
          } catch (err) {
            console.error(`좌표 변환 실패 (${item.addr}):`, err);
            return null; // 실패한 항목은 null 처리
          }
        })
      );
      results.push(...batchResults);
      await new Promise((resolve) => setTimeout(resolve, 5)); // 100ms 대기
    }
    return results;
  };

  const handleUpdateCoordinates = async () => {
    setIsUpdating(true);
    try {
      // 배치 처리로 좌표 변환
      const coordinates = await processWithBatching(idxList, 5);

      // 실패한 항목 제외
      const validCoordinates = coordinates.filter((coord) => coord !== null);

      // 유효한 좌표를 서버로 전송
      if (validCoordinates.length > 0) {
        await axios.post("/prupdateCoordinatesBatch", { coordinates: validCoordinates });
      }

      alert("좌표 업데이트가 완료되었습니다.");
      window.location.href = "/admin/form/schedule";
    } catch (err) {
      console.error("좌표 업데이트 중 오류:", err);
      alert("좌표 업데이트 중 문제가 발생했습니다.");
    } finally {
      setIsUpdating(false);
    }
  };
  return (
    <div>
      <ADMIN_HEADER />
      {isUpdating && (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      )}
      <div className="admin_write">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 창업 일정 관리</span>
        </div>
        <table>
          <tbody>
            <tr>
              <td>
                <div className="sec-snb">
                  <h3 className="snb_tit">데이터 관리</h3>
                  <ul className="snb_list">
				  {permissions.ent && (
				    <li>
				      <a href="/admin/form/ent">입회신청 관리</a>
				    </li>
				  )}
				  {permissions.fr && (
				    <li>
				      <a href="/admin/form/fr">창업신청 관리</a>
				    </li>
				  )}
				  {permissions.franchise && (
				    <li>
				      <a href="/admin/form/franchise">가맹점 관리</a>
				    </li>
				  )}
				  {permissions.schedule && (
				    <li className="cur">
				      <a href="/admin/form/schedule">창업일정 관리</a>
				    </li>
				  )}
				  {permissions.jisa && (
				    <li>
				      <a href="/admin/form/jisa">지사장 지원 관리</a>
				    </li>
				  )}
				  {permissions.q && (
				    <li>
				      <a href="/admin/form/q">앱 문의 관리</a>
				    </li>
				  )}
				  {permissions.etc_q && (
				    <li>
				      <a href="/admin/form/etc_q">기타문의 관리</a>
				    </li>
				  )}
                    {(localStorage.getItem("adminId") === "jiwoo" ||
                      localStorage.getItem("adminId") === "nixona" ||
                      localStorage.getItem("adminId") === "wjdrnr90" ||
                      localStorage.getItem("adminId") === "hyoseon.jang") && (
                      <li>
                        <a href="/admin/form/point">적립금 정산 관리</a>
                      </li>
                    )}
                  </ul>
                </div>
              </td>
              <td>
                <div className="bx-top">창업일정 좌표 업데이트</div>
                <div className="tb_01 wr">
                  <div className="sec-cont">
                    <button
                      type="button"
                      onClick={handleUpdateCoordinates}
                      disabled={isUpdating}
                      className="coordinateupdate"
                    >
                      {isUpdating
                        ? "업데이트 중입니다 잠시 기다려주세요..."
                        : "좌표 업데이트"}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admin_Schedule_map_up;
